import { defineMessages } from 'react-intl';

export default defineMessages({
	defaultFallback: {
		id: 'dev-agents.error-boundary.default-fallback',
		defaultMessage: 'Something went wrong',
		description: 'Default fallback message shown when an error occurs',
	},
	flagTitle: {
		id: 'dev-agents.error-boundary.flag.title',
		defaultMessage: 'Something went wrong on our end',
		description: 'Title of the error flag shown when an error is caught by the error boundary',
	},
	flagDescription: {
		id: 'dev-agents.error-boundary.flag.description',
		defaultMessage: 'Try refreshing the page. If the problem persists, contact support.',
		description:
			'Description of the error flag shown when an error is caught by the error boundary',
	},
	flagReloadButton: {
		id: 'dev-agents.error-boundary.flag.reload-button',
		defaultMessage: 'Reload page',
		description: 'Button text to reload the page in the error flag',
	},
	flagIconLabel: {
		id: 'dev-agents.error-boundary.flag.icon-label',
		defaultMessage: 'Error',
		description: 'Accessibility label for the error icon in the error flag',
	},
});
